/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon24Solid = forwardRef('UiMenuDots8VIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.75 5.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" }),
        React.createElement("path", { d: "M8.75 11.334a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" }),
        React.createElement("path", { d: "M11 14.918a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" }),
        React.createElement("path", { d: "M8.75 23.002a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" }),
        React.createElement("path", { d: "M17.5 3.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" }),
        React.createElement("path", { d: "M15.25 11.334a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" }),
        React.createElement("path", { d: "M17.5 14.918a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" }),
        React.createElement("path", { d: "M15.25 23.002a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" })));
});
